import { ForwardedRef, forwardRef } from "react"
import { FormSelect, FormSelectProps } from "./Select"
import { countryOptions } from "@nano-portal/customers"

type Props = Omit<FormSelectProps<typeof countryOptions>, "options" | "placeholder" | "required">

function CountrySelectRaw(props: Props, ref: ForwardedRef<HTMLSelectElement>) {
  const { id = "country", ...rest } = props
  return <FormSelect id={id} ref={ref} options={countryOptions} required {...rest} />
}

export const CountrySelect = forwardRef(CountrySelectRaw)
